import React, { useState, } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function EditItem() {
  const location = useLocation(); // expects item passed via state
  const navigate = useNavigate();
  const item = location.state?.item;

  const [title, setTitle] = useState(item?.title || "");
  const [description, setDescription] = useState(item?.description || "");
  const [cost, setCost] = useState(item?.cost || "");
  const [kijiji, setKijiji] = useState(item?.kijiji || "");
  const [ebay, setEbay] = useState(item?.ebay || "");
  const [link, setLink] = useState(item?.link || "");
  const [dateAdded, setDateAdded] = useState(item?.date_added || "");
  const [quantity, setQuantity] = useState(item?.quantity || 1);

    const handleUpdate = async () => {
        const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));
        
        await fetch("https://liquidationapi.dallasagsmith.workers.dev/update", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                token: match[2],
                title,
                description,
                cost,
                kijiji,
                ebay,
                link,
                date_added: dateAdded,
                item,
                quantity
            }),
        });

        if (quantity > item.quantity) {
            const extra = quantity - item.quantity;
            for (let i = 0; i < extra; i++) {
                await fetch("https://liquidationapi.dallasagsmith.workers.dev/add", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        token: match[2],
                        title: title,
                        description: description,
                        cost: cost,
                        kijiji: kijiji,
                        ebay: ebay,
                        link: link,
                        date_added: dateAdded,
                        quantity: quantity
                    }),
                });
            }
        }



        console.log(item.id);
        navigate("/inventory");
    };


  return (
    <div className="page-container">
      <h2>Edit Item</h2>
      <div className="card" style={{ maxWidth: "500px", margin: "0 auto" }}>
        <label style={{ fontWeight: "bold" }}>Title</label>
        <input
        style={{ width: "95%" }}
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Description</label>
        <textarea
        style={{ width: "95%" }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Cost of each</label>
        <input
        style={{ width: "95%" }}
          type="number"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}># of items to update</label>
        <input
        style={{ width: "95%" }}
          type="number"
          min={1}
          max={item?.quantity || 1}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
        />

        <label style={{ fontWeight: "bold" }}>Date Added</label>
        <input
        style={{ width: "95%" }}
          type="date"
          value={dateAdded}
          onChange={(e) => setDateAdded(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Kijiji URL</label>
        <input
        style={{ width: "95%" }}
          type="url"
          value={kijiji}
          onChange={(e) => setKijiji(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Facebook Marketplace URL</label>
        <input
        style={{ width: "95%" }}
          type="url"
          value={ebay}
          onChange={(e) => setEbay(e.target.value)}
        />

        <label style={{ fontWeight: "bold" }}>Other Link</label>
        <input
        style={{ width: "95%" }}
          type="url"
          value={link}
          onChange={(e) => setLink(e.target.value)}
        />

        <button
          onClick={handleUpdate}
          style={{ marginTop: "15px", width: "100%" }}
        >
          Update Item
        </button>
      </div>
    </div>
  );
}

export default EditItem;
